import { render } from "./AddPromotion.vue?vue&type=template&id=2bc53095"
import script from "./AddPromotion.vue?vue&type=script&lang=js"
export * from "./AddPromotion.vue?vue&type=script&lang=js"

import "./AddPromotion.vue?vue&type=style&index=0&id=2bc53095&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__